<template lang="html">
  <div class="sailWindSucceed">
    <img src="@/assets/image/sailWind/img1.png" alt="">
    <p class="hint">您的表单已提交～</p>

    <div class="particulars">
      <p>如何充分使用<b>派兹SailWind的免费试用版, 请单击电子邮件中的下载链接</b>。</p>
      <p>如果您在收件箱或垃圾邮件文件夹中未发现上述电子邮件，请与我们联系0755-86703052。</p>
    </div>

    <div class="particulars">
      <p>下载并安装<b>派兹SailWind</b></p>
      <p>打开.zip文件并按照安装提示进行操作。在安装过程中，系统将要求您进行身份验证。</p>
    </div>

    <div class="particulars">
      <p>还有更多功能！</p>
      <p>请前往<b>【派兹资源中心】</b>，以充分了解<b>派滋SailWind</b>的免费试用版。</p>
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="css" scoped>
.sailWindSucceed{
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 2rem;
}

.sailWindSucceed img {
  width: 11.9rem;
  height: 11.9rem;
  margin-top: 4.5rem;
}

.hint {
  font-size: 1.6rem;
  font-weight: 600;
  color: #333333;
  margin-top: 1rem;
}

.particulars {
  margin-top: 2rem;
  font-size: 1.5rem;
}
</style>